// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-input[data-v-75302e11]{width:130px}.custom-label[data-v-75302e11]{width:150px}", ""]);
// Exports
module.exports = exports;
